import { Flex, Typography, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const { Text } = Typography;

export const ProcessingBanner = () => (
  <Flex
    align='center'
    gap={12}
    style={{
      width: '90%',
      padding: '8px 10px',
      marginBottom: 8,
      borderRadius: 8,
      backgroundColor: '#e6f4ff',
      border: '1px solid #91caff',
    }}
  >
    <Spin indicator={<LoadingOutlined spin style={{ fontSize: 'inherit', color: '#1677ff' }} />} style={{ fontSize: '1.4em' }} />
    <Flex vertical gap={4} style={{ textAlign: 'left' }}>
      <Text strong style={{ fontSize: '0.9em', lineHeight: 1 }}>
        Procesando cotización
      </Text>
      <Text type='secondary' style={{ fontSize: '0.8em', lineHeight: 1.4 }}>
        Un momento, estamos completando la información…
      </Text>
    </Flex>
  </Flex>
);
